import { Injectable, inject } from '@angular/core';

import { OddsFormatterService } from '@frontend/sports/odds/feature';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { ISlip } from '../../../../../bet-generation/models';
import { CriteriaType, TokenOddsData } from '../../../../../reward-tokens/reward-tokens.model';
import { mapOdds } from '../../../../../reward-tokens/services/reward-tokens.utils';
import { RewardTokensTotalOddsError } from '../../../../errors/general/betandget/reward-tokens-total-odds-error';
import { SlipValidationContext } from '../../../../models/models';
import { IContextSlipValidator } from '../validators';

@Injectable()
export class RewardTokensTotalOddsValidator implements IContextSlipValidator<RewardTokensTotalOddsError> {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    constructor(private oddsFormatterService: OddsFormatterService) {}

    validate(_: ISlip, { rewardTokens }: SlipValidationContext): RewardTokensTotalOddsError[] {
        const selectedToken = rewardTokens.selectedToken;
        const eligibilityState = rewardTokens.selectedTokenEligibilityState;

        if (!selectedToken || !eligibilityState || eligibilityState.softCriteriasValidity[CriteriaType.TotalOdds] !== false) {
            return [];
        }

        return [new RewardTokensTotalOddsError(this.mapOdds(selectedToken.minimumOdds))];
    }

    private mapOdds(minOddsPerLeg: TokenOddsData | undefined): string {
        return this.oddsFormatterService.format(mapOdds(minOddsPerLeg), { displayFormat: this.userOddsFormatSettingsService.oddsFormat });
    }
}
